import log from 'chameleon/ui-stack/utilities/log';
import { getPerformanceTiers } from 'legacy/src/queries';
import { fymClient } from 'legacy-src/utility/GraphqlClients';
import React, { useEffect, useState } from 'react';

const initialState = [
  // Defaults to AP tiers
  {
    type: 'tier1',
    label: 'Developing',
    bottomLimit: 0,
    topLimit: 39,
    color: 'yellow',
    __typename: 'Tier',
  },
  {
    type: 'tier2',
    label: 'Approaching',
    bottomLimit: 40,
    topLimit: 74,
    color: 'light-green',
    __typename: 'Tier',
  },
  {
    type: 'tier3',
    label: 'Achieving',
    bottomLimit: 75,
    topLimit: 100,
    color: 'green',
    __typename: 'Tier',
  },
];

export const getPerformanceTierType = (performanceTiers) => {
  if (performanceTiers?.length === 3) {
    return {
      tier1: 'tier-developing',
      tier2: 'tier-approaching',
      tier3: 'tier-achieving',
    };
  } else {
    return {
      tier1: 'tier-developing',
      tier2: 'tier-approaching',
      tier3: 'tier-progressing',
      tier4: 'tier-achieving',
    };
  }
};

export const getTierColorClasses = (performanceTiers, tier) => {
  const tierBaseColor = performanceTiers.find(
    ({ type }) => type === tier,
  )?.color;

  let tierColor;
  switch (tierBaseColor) {
    case 'yellow':
      tierColor = 'bg-yellow-400 text-yellow-900 hover:bg-yellow-300';
      break;
    case 'light-yellow':
      tierColor = 'bg-yellow-200 text-yellow-900 hover:bg-yellow-100';
      break;
    case 'green':
      tierColor = 'bg-green-400 text-green-900 hover:bg-green-300';
      break;
    case 'light-green':
      tierColor = 'bg-green-200 text-green-900 hover:bg-green-100';
      break;
    default:
      tierColor = 'bg-gray-200 text-black';
  }
  return tierColor;
};

const tiersCache = {};

const usePerformanceTiers = (subjectId) => {
  const [isLoading, setIsLoading] = useState(false);
  const [performanceTiers, setPerformanceTiers] = useState(initialState);

  const tiersQuery = (subjectId) => {
    if (subjectId in tiersCache) {
      setPerformanceTiers(tiersCache[subjectId]);
      return;
    }

    setIsLoading(true);
    fymClient
      .query({
        query: getPerformanceTiers,
        variables: { subjectId },
      })
      .then((resp) => {
        const data = resp.data || {};
        tiersCache[subjectId] = data.performanceTiers || [];
        setPerformanceTiers(data.performanceTiers || []);
        setIsLoading(false);
      })
      .catch((error) => {
        log('error', error);
        /**
         * Reset the config if it's not available
         * */
        setPerformanceTiers([]);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    tiersQuery(subjectId);
  }, [subjectId]);

  return {
    isLoading,
    performanceTiers,
  };
};

/** DO NOT USE, you should use the hook usePerformanceTier,
 * we are creating this HOC just to avoid rewriting class components
 */
export const withPerformanceTier = (Component) => (props) => {
  const { subjectId } = props;
  const { performanceTiers } = usePerformanceTiers(subjectId);
  return <Component {...props} performanceTiers={performanceTiers} />;
};

export default usePerformanceTiers;
